import moment from 'moment';

export const DEFAULT_DATE_FORMAT = 'MM-DD-YYYY hh:mm:ss A Z';

export const formatDate = (date, format = DEFAULT_DATE_FORMAT) => {
  return moment(date).format(format);
};
